import { z } from 'zod';
import {
  schema as generalInformationSchema,
  strictSchema as strictGeneralInformationSchema,
} from './GeneralInformation/schema';
import {
  schema as noticeNarrativeSchema,
  strictSchema as strictNoticeNarrativeSchema,
} from './NoticeNarrative/schema';
import {
  schema as useOfFundsSchema,
  strictSchema as strictUseOfFundsSchema,
} from './UseOfFunds/schema';
import {
  schema as notificationPreferencesSchema,
  strictSchema as strictNotificationPreferencesSchema,
} from './NotificationPreferences/schema';
import {
  schema as perInvestorBreakdownSchema,
  strictSchema as perInvestorBreakdownStrictSchema,
} from './PerInvestorBreakdown/schema';

const draftSchema = z.object({
  useFullValidation: z.literal(false),
  generalInformation: generalInformationSchema,
  noticeNarrative: noticeNarrativeSchema,
  useOfFunds: useOfFundsSchema,
  notificationPreferences: notificationPreferencesSchema,
  perInvestorBreakdown: perInvestorBreakdownSchema,
  resendPublishedNotices: z.boolean(),
});

const fullValidationSchema = z.object({
  useFullValidation: z.literal(true),
  generalInformation: strictGeneralInformationSchema,
  noticeNarrative: strictNoticeNarrativeSchema,
  useOfFunds: strictUseOfFundsSchema,
  notificationPreferences: strictNotificationPreferencesSchema,
  perInvestorBreakdown: perInvestorBreakdownStrictSchema,
  resendPublishedNotices: z.boolean(),
});

export const schema = z.discriminatedUnion('useFullValidation', [
  draftSchema,
  fullValidationSchema,
]);

export type CreateNoticeSchemaFormValues = z.infer<typeof schema>;

export type FullyValidatedCreateNoticeSchemaFormValues = z.infer<
  typeof fullValidationSchema
>;
